import { render, staticRenderFns } from "./AddDeviceToUser.vue?vue&type=template&id=f5bf3e22&scoped=true&"
import script from "./AddDeviceToUser.vue?vue&type=script&lang=js&"
export * from "./AddDeviceToUser.vue?vue&type=script&lang=js&"
import style0 from "./AddDeviceToUser.vue?vue&type=style&index=0&id=f5bf3e22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bf3e22",
  null
  
)

export default component.exports